import * as React from 'react'
import {withAuthenticationRequired} from '@auth0/auth0-react';
import {LoadingLayout} from '~components/LoadingLayout';

import {Loader} from '~components/Icons'
import {Helmet} from 'react-helmet-async'

const Wrapper = ({children}) => <React.Fragment>
    <Helmet>
        <link rel="shortcut icon" href="https://www.citnow.com/app/themes/madebrave/assets/img/favicon.ico" type="image/x-icon"/>
        <link rel="icon" sizes="16x16" href="https://www.citnow.com/app/themes/madebrave/assets/img/favicon/favicon.png" type="image/png"/>
        <link rel="icon" sizes="32x32" href="https://www.citnow.com/app/themes/madebrave/assets/img/favicon/favicon@2x.png" type="image/png"/>
        <link rel="icon" sizes="48x48" href="https://www.citnow.com/app/themes/madebrave/assets/img/favicon/favicon@3x.png" type="image/png"/>
        <link rel="apple-touch-icon-precomposed" sizes="120x120" href="https://www.citnow.com/app/themes/madebrave/assets/img/touchicon/iphone@2x.png"/>
        <link rel="apple-touch-icon-precomposed" sizes="152x152" href="https://www.citnow.com/app/themes/madebrave/assets/img/touchicon/ipad@2x.png"/>
        <link rel="apple-touch-icon-precomposed" sizes="180x180" href="https://www.citnow.com/app/themes/madebrave/assets/img/touchicon/iphone@3x.png"/>
        <link rel="apple-touch-icon-precomposed" sizes="228x228" href="https://www.citnow.com/app/themes/madebrave/assets/img/touchicon/ipad@3x.png"/>
    </Helmet>
    {children}
</React.Fragment>;

export default withAuthenticationRequired(Wrapper, {
    onRedirecting: () => {
        return (
            <LoadingLayout><Loader/></LoadingLayout>)
    },
    loginOptions: {
        appState: {
            hash: typeof window !== `undefined` ? window.location.hash : null
        }
    }
});